import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import { api } from '../../api/api';

interface Account {
  record_id: number;
  record_title: string;
  record_description: string;
  record_image_url: string;
  record_price: number;
  record_game_name: string;
  record_league: string;
  user_nickName: string; // Assuming user data is also flattened and prefixed
  user_email: string;
}

const AccountView = () => {
  const { id } = useParams<{ id: string }>();
  const [account, setAccount] = useState<Account | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAccount = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/api/all/account_sales/${id}`);
        setAccount(response.data);
      } catch (err: any) {
        setError(err.message || 'Failed to fetch account');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchAccount();
    }
  }, [id]);

  if (loading) return <div className="text-white text-center py-10">Loading account...</div>;
  if (error) return <div className="text-red-500 text-center py-10">Error: {error}</div>;
  if (!account) return <div className="text-white text-center py-10">Account not found</div>;

  return (
    <div className="bg-gray-900 text-white min-h-screen">
      <Header />
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-2">
            <div className="bg-gray-800 p-4 rounded-lg">
              <img src={account.record_image_url} alt={account.record_title} className="w-full h-auto rounded-lg" />
            </div>
            <div className="mt-8">
              <h2 className="text-2xl font-bold mb-4">Description</h2>
              <p className="text-gray-400">{account.record_description}</p>
            </div>
          </div>
          <div>
            <div className="bg-gray-800 p-4 rounded-lg">
              <h1 className="text-3xl font-bold">{account.record_title}</h1>
              <div className="text-yellow-400 text-2xl font-bold my-4">${Number(account.record_price).toFixed(2)}</div>
              <button className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded w-full">Add to Cart</button>
              <div className="mt-4 text-sm text-gray-400">Delivery in 15 minutes</div>
            </div>
            <div className="bg-gray-800 p-4 rounded-lg mt-4">
              <h2 className="text-xl font-bold mb-4">Seller Information</h2>
              <div className="flex items-center">
                <img src="https://via.placeholder.com/50" alt="Seller Avatar" className="w-12 h-12 rounded-full" />
                <div className="ml-4">
                  <div className="font-bold">{account.user_nickName || account.user_email || 'N/A'}</div>
                  <div className="text-sm text-gray-400">98% Positive Feedback</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AccountView;